import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import LinkButton from '/shared/components/widgets/button/LinkButton';
import { apiEndpoint } from '/shared/util/Statics';
import ElectricityHeatSteamEmissionsDisplay from '/business/shared/components/questions/scope2/_education/ElectricityHeatSteamEmissionsDisplay';
const methodologyStatement = `${apiEndpoint}/api/b2b/get_static_file?type=methodology`;

export const BottomConsumptionPage = (
  <>
    <div className="hse-landingbtm">
      <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
        Inputting consumption data
      </StyledHeading>
      <StyledParagraph $largeText>For each defined location, enter the following:</StyledParagraph>
      <ul>
        <li>
          <StyledParagraph $largeText>
            The <b>type of energy consumed</b>
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            The <b>amount used</b> (from activity or supplier intensity data)
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            Any <b>energy attribute certificates</b> associated with that location
          </StyledParagraph>
        </li>
      </ul>
      <StyledParagraph $largeText>
        This data will support accurate emissions calculations and provide a clearer understanding of your energy use by
        location.
      </StyledParagraph>

      <StyledParagraph $largeText>
        For more information on how this is calculated please read the{' '}
        <LinkButton href={methodologyStatement}>methodology statement</LinkButton>.
      </StyledParagraph>
      <ElectricityHeatSteamEmissionsDisplay />
    </div>
  </>
);
